export default __webpack_public_path__ + "static/media/avatar_koala1.6a97a8c1.mp3";